import { render, staticRenderFns } from "./OrgAdminSideNav.vue?vue&type=template&id=79e715d9&scoped=true&"
import script from "./OrgAdminSideNav.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminSideNav.vue?vue&type=style&index=0&id=79e715d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e715d9",
  null
  
)

export default component.exports